var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "485px",
    height: "485px",
    viewBox: "0 0 485 485",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Paymnet_Tap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Concept-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purchase-Instructions---Swipe",
    transform: "translate(-1130.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paymnet_Tap",
    transform: "translate(1130.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D9E1E7",
    fillRule: "nonzero",
    cx: 242.5,
    cy: 242.5,
    r: 242.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Credit-Card",
    transform: "translate(242.321987, 245.491679) rotate(168.000000) translate(-242.321987, -245.491679) translate(102.321987, 57.491679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1674856,18.4636261 L233.797476,18.508461 C240.974751,18.516387 246.792654,24.3342918 246.800578,31.5115671 L246.875174,344.025471 C246.883096,351.205171 241.064187,357.026858 233.884486,357.028572 C233.882416,357.028572 233.880346,357.028572 233.878278,357.022364 L46.2482874,356.977529 C39.0710122,356.969603 33.2531089,351.151698 33.2451848,343.974423 L33.1705891,31.4605193 C33.1626673,24.2808192 38.9815761,18.4591319 46.1612777,18.4574181 C46.1633475,18.4574176 46.1654173,18.4574176 46.1674856,18.4636261 Z",
    id: "Card",
    stroke: "#000000",
    strokeWidth: 3.36,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(140.022882, 187.742995) rotate(11.910000) translate(-140.022882, -187.742995) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4579212,265.047448 L96.4462157,265.056001 C100.862995,265.060982 104.443169,268.641296 104.447975,273.058075 L104.456162,310.273436 C104.460967,314.691713 100.880033,318.274223 96.4617548,318.275195 C96.4604768,318.275195 96.4591987,318.275195 96.4579217,318.271361 L63.4696271,318.262808 C59.0528475,318.257827 55.4726742,314.677513 55.4678676,310.260734 L55.4596812,273.045373 C55.4548761,268.627096 59.0358101,265.044586 63.454088,265.043614 C63.4553661,265.043614 63.4566441,265.043614 63.4579212,265.047448 Z",
    id: "Chip",
    fill: "#D9E1E7",
    fillRule: "nonzero",
    transform: "translate(79.957921, 291.659404) rotate(11.910000) translate(-79.957921, -291.659404) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.42492,
    y1: 86.4023655,
    x2: 157.70691,
    y2: 334.572578,
    id: "Card-Number-Line",
    stroke: "#000000",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.377159,
    y1: 304.87123,
    x2: 184.332136,
    y2: 340.488251,
    id: "Name-of-Card",
    stroke: "#000000",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.162908,
    y1: 63.4630186,
    x2: 91.9433934,
    y2: 121.988606,
    id: "Top-Line",
    stroke: "#000000",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPayment);
export default __webpack_public_path__ + "static/media/credit_card_payment.ff1c14dc160450312ced3c8d99ffc165.svg";
export { ForwardRef as ReactComponent };